// src/app/app.module.ts

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { LeadsListComponent } from './leads-list/leads-list.component';
import { AddLeadModalComponent } from './modal/add-lead-modal/add-lead-modal.component';
import { UploadFileModalComponent } from './modal/upload-file-modal/upload-file-modal.component';
import { QueriesListComponent } from './queries-list/queries-list.component';
import { LoginComponent } from './login/login.component';
import { LeadDetailsModalComponent } from './modal/lead-details-modal/lead-details-modal.component';
import { AddNotesModalComponent } from './modal/add-notes-modal/add-notes-modal.component';
import { UpdateStatusModalComponent } from './modal/update-status-modal/update-status-modal.component';

import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';

import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { LeadViewComponent } from './lead-view/lead-view.component';
import { TimelineNotesComponent } from './timeline-notes/timeline-notes.component';
import { ViewDocumentComponent } from './queries-list/view-document/view-document.component';
import { ViewDocumentModalComponent } from './modal/view-document-modal/view-document-modal.component';
import { ForgotpwdComponent } from './login/forgotpwd/forgotpwd.component';
import { ResetpwdComponent } from './login/resetpwd/resetpwd.component';
import { AttachMatterComponent } from './queries-list/attach-matter/attach-matter.component';
import { MatterComponent } from './matter/matter.component';
import { QueriesViewComponent } from './queries-view/queries-view.component';

import { ConfirmationComponent } from './modal/confirmation/confirmation.component';
import { ConfirmationDialogComponent } from './modal/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './modal/confirmation-dialog/confirmation-dialog.service';

import { ViewlegalmatterComponent } from './matter/legalmatter/viewlegalmatter/viewlegalmatter.component';
import { InternalmatterComponent } from './matter/legalmatter/internalmatter/internalmatter.component';
import { ExternalmatterComponent } from './matter/legalmatter/externalmatter/externalmatter.component';

import {
  MatterTeamMembersComponent
} from './matter/legalmatter/createlegalmatter/matter-team-members/matter-team-members.component';

import {
  MatterInfoComponent
} from './matter/legalmatter/createlegalmatter/matter-info/matter-info.component';

import {
  AddAdivicateComponent
} from './matter/legalmatter/createlegalmatter/matter-info/add-adivicate/add-adivicate.component';

import {
  MatterGroupsComponent
} from './matter/legalmatter/createlegalmatter/matter-groups/matter-groups.component';

import {
  MatterDocumentsComponent
} from './matter/legalmatter/createlegalmatter/matter-documents/matter-documents.component';

import {
  MatterClientsComponent
} from './matter/legalmatter/createlegalmatter/matter-clients/matter-clients.component';

import {
  CreatelegalmatterComponent
} from './matter/legalmatter/createlegalmatter/createlegalmatter.component';

import { RouterModule } from '@angular/router';

import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { A11yModule } from '@angular/cdk/a11y';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { OverlayModule } from '@angular/cdk/overlay';
import { CdkMenuModule } from '@angular/cdk/menu';
import { DialogModule } from '@angular/cdk/dialog';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';

import { NgxFileDropModule } from 'ngx-file-drop';

import { MatterRoutingModule } from './matter/matter-routing.module';

import { DocumentComponent } from './document/document.component';
import { DownloadDetailsComponent } from './queries-list/download-details/download-details.component';
import { ReviewDetailsComponent } from './queries-list/review-details/review-details.component';

import { SubscriptionViewComponent } from './subscription-view/subscription-view.component';
import { PlanDetailsComponent } from './plan-details/plan-details.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LawyersListComponent } from './lawyers-list/lawyers-list.component';
import { ContactusComponent } from './contact-us/contact-us.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientHistoryComponent } from './client-history/client-history.component';
import { LawyerHistoryComponent } from './lawyer-history/lawyer-history.component';

import { NotificationsModule } from './notifications/notifications.module';
import { OtherProductsComponent } from './other-products/other-products.component';
import { CorporateListComponent } from './corporate-list/corporate-list.component';
import { LexizClientComponent } from './lexiz-client/lexiz-client.component';
import { LexizLawyerComponent } from './lexiz-lawyer/lexiz-lawyer.component';

import { AppointmentsComponent } from './appointments/appointments.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';

import { FilterModule } from './service/filter.module';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    TopbarComponent,
    LeadsListComponent,

    AddNotesModalComponent,
    AddLeadModalComponent,
    UploadFileModalComponent,

    QueriesListComponent,
    LoginComponent,
    ForgotpwdComponent,
    ResetpwdComponent,

    LeadDetailsModalComponent,
    UpdateStatusModalComponent,

    ViewDocumentComponent,
    ViewDocumentModalComponent,

    ConfirmationDialogComponent,
    ConfirmationComponent,

    LeadViewComponent,
    TimelineNotesComponent,

    AttachMatterComponent,
    MatterComponent,
    InternalmatterComponent,
    ExternalmatterComponent,

    MatterTeamMembersComponent,
    QueriesViewComponent,
    ViewlegalmatterComponent,
    MatterInfoComponent,
    AddAdivicateComponent,
    MatterGroupsComponent,
    MatterDocumentsComponent,
    MatterClientsComponent,
    CreatelegalmatterComponent,

    

    DocumentComponent,
    DownloadDetailsComponent,
    ReviewDetailsComponent,

    SubscriptionViewComponent,
    PlanDetailsComponent,
    SubscriptionPlansComponent,

    LawyersListComponent,
    ContactusComponent,
    ClientListComponent,

    OtherProductsComponent,
    CorporateListComponent,

    LexizClientComponent,
    LexizLawyerComponent,

    DashboardAdminComponent,
    AppointmentsComponent,
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    BrowserAnimationsModule,

    // Bootstrap
    NgbModule,
    NgbModalModule,
    BsDatepickerModule.forRoot(),

    // Spinner / Toast
    NgxSpinnerModule,
    ToastrModule.forRoot(),

    // Autocomplete
    AutocompleteLibModule,
    
    // Angular Material
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,

    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,

    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatListModule,
    MatRippleModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTreeModule,

    // CDK
    A11yModule,
    CdkAccordionModule,
    ClipboardModule,
    DragDropModule,
    PortalModule,
    ScrollingModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    OverlayModule,
    CdkMenuModule,
    DialogModule,

    // File drop
    NgxFileDropModule,

    // Routing
    MatterRoutingModule,

    // Notifications
    NotificationsModule,

    LawyerHistoryComponent,
    ClientHistoryComponent,

    // Custom filter
    FilterModule,
  ],

  providers: [
    ConfirmationDialogService,
    provideHttpClient(withInterceptorsFromDi())
  ],

  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  bootstrap: [
    AppComponent
  ]
})
export class AppModule {}